import { render, staticRenderFns } from "./my-qrcode.vue?vue&type=template&id=e2422d1a&scoped=true&"
import script from "./my-qrcode.vue?vue&type=script&lang=js&"
export * from "./my-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./my-qrcode.vue?vue&type=style&index=0&id=e2422d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2422d1a",
  null
  
)

export default component.exports